import { AlertTriangle, Trash2 } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { fmt } from "@/lib/api";

export const DuplicateBanner = ({ groups, onDelete }) => {
  if (!groups || groups.length === 0) return null;
  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: -6 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0 }}
        data-testid="duplicate-banner"
        className="bg-amber-50 border border-amber-300 rounded-lg p-4"
      >
        <div className="flex items-start gap-3">
          <AlertTriangle className="h-5 w-5 text-amber-600 mt-0.5 shrink-0" />
          <div className="flex-1">
            <p className="font-heading font-bold text-amber-900">
              {groups.length} possible duplicate group{groups.length > 1 ? "s" : ""} found
            </p>
            <p className="text-sm text-amber-700 mb-3">
              These transactions share the same amount and date (e.g. a check that's also on the
              statement). Remove any you don't want counted twice.
            </p>
            <div className="space-y-2">
              {groups.map((g, gi) => (
                <div key={gi} className="bg-white border border-amber-200 rounded-md p-2">
                  <div className="text-xs font-semibold text-gray-500 mb-1">
                    {g.date || "no date"} · <span className="font-mono">{fmt(g.amount)}</span>
                  </div>
                  <div className="space-y-1">
                    {g.transactions.map((t) => (
                      <div
                        key={t.id}
                        className="flex items-center justify-between text-sm px-2 py-1 rounded hover:bg-amber-50"
                      >
                        <span className="truncate">
                          {t.description}
                          {t.source_type === "check" && (
                            <span className="ml-2 text-xs px-1.5 py-0.5 rounded bg-gray-100 text-gray-600">
                              check
                            </span>
                          )}
                        </span>
                        <button
                          data-testid={`dup-delete-${t.id}`}
                          onClick={() => onDelete(t.id)}
                          className="text-gray-400 hover:text-rose-600 transition-colors ml-2"
                        >
                          <Trash2 className="h-4 w-4" />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};
